   import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Separator } from "@/components/ui/separator";
import { FileText } from "lucide-react";

const Terms = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />

      <main className="flex-grow pt-16">
        {/* Hero section */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-brand-50 to-white"></div>
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold mb-6">
                Kushtet e Përdorimit
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                Kushtet dhe rregullat për përdorimin e platformës sonë.
              </p>
              <div className="flex justify-center items-center text-sm text-gray-500">
                <span>Përditësuar së fundmi: 15 Mars, 2023</span>
              </div>
            </div>
          </div>
        </section>

        {/* Terms content */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
                <div className="flex items-center mb-6">
                  <FileText size={24} className="text-brand-500 mr-3" />
                  <h2 className="text-2xl font-bold">
                    Kushtet e Përdorimit të TreguIm
                  </h2>
                </div>

                <div className="prose prose-stone max-w-none">
                  <p>
                    Mirë se vini në TreguIm. Këto Kushte Përdorimi rregullojnë
                    përdorimin tuaj të platformës sonë. Duke përdorur
                    platformën, ju pranoni këto kushte, kështu që ju lutemi
                    lexojini me kujdes.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">1. Përkufizime</h3>
                  <p>
                    "TreguIm", "Ne", "Platforma jonë" i referohet platformës
                    TreguIm.org.
                  </p>
                  <p>
                    "Përdorues" i referohet çdo personi që përdor platformën,
                    përfshirë blerësit dhe shitësit.
                  </p>
                  <p>
                    "Përmbajtje" i referohet çdo informacioni, teksti, imazhi,
                    ose materiali tjetër që postohet në platformë.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    2. Regjistrimi dhe Llogaritë
                  </h3>
                  <p>
                    Për të përdorur disa funksione të platformës, ju duhet të
                    regjistroheni dhe të krijoni një llogari. Ju jeni përgjegjës
                    për mbajtjen e konfidencialitetit të informacionit të
                    llogarisë suaj dhe jeni plotësisht përgjegjës për të gjitha
                    veprimet që ndodhin nën llogarinë tuaj.
                  </p>
                  <p>
                    Ju duhet të njoftoni menjëherë Tregu për çdo përdorim të
                    paautorizuar të llogarisë suaj ose të ndonjë cenimi tjetër
                    të sigurisë. TreguIm nuk mund të mbahet përgjegjës për humbjet
                    e shkaktuara nga përdorimi i paautorizuar i llogarisë suaj.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    3. Përmbajtja e Përdoruesit
                  </h3>
                  <p>
                    Ju mbani pronësinë e të gjitha përmbajtjeve që postoni në
                    platformë, por ju jepni TreguIm një licencë jo-ekskluzive, pa
                    pagesë, të transferueshme, nën-licencueshme, të pakthyeshme
                    dhe pa kufizim për të përdorur, riprodhuar, modifikuar,
                    përshtatur, publikuar, përkthyer, shpërndarë dhe shfaqur
                    përmbajtjen në lidhje me shërbimet e Tregu.
                  </p>
                  <p>Ju nuk duhet të postoni përmbajtje që:</p>
                  <ul className="list-disc pl-6 mb-4">
                    <li>
                      është e paligjshme, mashtruese, kërcënuese, abuzive,
                      ngacmuese, shpifëse, vulgare ose ndryshe e papërshtatshme;
                    </li>
                    <li>
                      shkel të drejtat e pronësisë intelektuale të palëve të
                      treta;
                    </li>
                    <li>promovon aktivitete të paligjshme;</li>
                    <li>
                      paraqet informacione personale të palëve të treta pa
                      pëlqimin e tyre;
                    </li>
                    <li>
                      përmban softuer virus ose çdo kod tjetër kompjuterik që
                      synon dëmtimin e sistemeve kompjuterike.
                    </li>
                  </ul>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    4. Transaksionet
                  </h3>
                  <p>
                    TreguIm është një platformë që lejon përdoruesit të blejnë dhe
                    shesin produkte. Ne nuk jemi palë në transaksionet mes
                    përdoruesve dhe nuk kemi kontroll mbi cilësinë, sigurinë ose
                    ligjshmërinë e artikujve të listuar, vërtetësinë e
                    shpalljeve, aftësinë e shitësve për të shitur artikuj ose
                    aftësinë e blerësve për të paguar për artikuj.
                  </p>
                  <p>
                    Përdoruesit duhet të përdorin gjykimin e tyre dhe të jenë të
                    kujdesshëm kur blejnë dhe shesin artikuj përmes platformës
                    sonë. TreguIm nuk mban asnjë përgjegjësi për humbjet e
                    shkaktuara nga përdorimi i platformës për transaksione.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    5. Përfundimi i Shërbimit
                  </h3>
                  <p>
                    TreguIm rezervon të drejtën të ndryshojë, pezullojë ose
                    përfundojë, përkohësisht ose përgjithmonë, shërbimin e
                    platformës (ose çdo pjesë të tij) me ose pa njoftim, në çdo
                    kohë. Ju pranoni që TreguIm nuk do të jetë përgjegjës ndaj
                    jush ose ndaj ndonjë pale të tretë për çdo ndryshim,
                    pezullim ose përfundim të shërbimit.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">
                    6. Ndryshimet në Kushtet e Përdorimit
                  </h3>
                  <p>
                    TreguIm rezervon të drejtën të ndryshojë këto Kushte të
                    Përdorimit në çdo kohë. Ne do t'ju njoftojmë për çdo
                    ndryshim material në këto kushte duke postuar kushtet e reja
                    në platformë. Përdorimi i vazhdueshëm i platformës pas
                    postimit të ndryshimeve do të përbëjë pranimin tuaj të
                    kushteve të rishikuara.
                  </p>

                  <Separator className="my-6" />

                  <h3 className="text-xl font-semibold mb-3">7. Kontakt</h3>
                  <p>
                    Nëse keni pyetje në lidhje me këto Kushte të Përdorimit, ju
                    lutemi na kontaktoni në:
                  </p>
                  <p>
                    Email: info@treguim.org
                    <br />
                    Adresa: Tiranë, Shqipëri
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
